export default {
  data: () => ({
    componentWidth: null,
    componentHeight: null,
    chartcontainerWidth: null,
    chartcontainerHeight: null,
    componentMobileClass: "",
    currentResizeTimeout: null
  }),
  mounted() {
    window.addEventListener("resize", this.bignumbersize_resize);
    this.$nextTick(this.bignumbersize_resize);
  },
  updated() {
    this.$nextTick(this.bignumbersize_resize);
  },
  methods: {
    bignumbersize_resize() {
      this.$nextTick(() => {
        if (this.currentResizeTimeout) {
          clearTimeout(this.currentResizeTimeout);
          this.currentResizeTimeout = null;
        }
        this.currentResizeTimeout = setTimeout(() => {
          this.componentWidth = this.$el.clientWidth;
          this.componentHeight = this.$el.clientHeight;

          if (this.componentWidth < 200) {
            this.componentMobileClass = "cmc_tiny";
          } else if (this.componentWidth < 350) {
            this.componentMobileClass = "cmc_mobile";
          } else {
            this.componentMobileClass = "cmc_normal";
          }

          var cc = this.$refs.chartcontainer;
          if (cc && cc.$refs) {
            cc = cc.$refs.chartcontainer;
          }
          if (cc) {
            this.chartcontainerWidth = cc.clientWidth;
            this.chartcontainerHeight = cc.clientHeight;
          }
        });
      }, 100);
    }
  }
};
